<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {},
};
</script>

<style lang="">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue